import EventEmitter from 'events'
import { constants, instances } from '../store'
import { gsap } from 'gsap/all'

const mediaQueryList = window.matchMedia("(max-width:767px)");

export default class GlobalHeader extends EventEmitter {
  constructor() {
    super()
    this.modifier = 'is-firstView';

    document.documentElement.classList.add(this.modifier)
    this.docScroll
    this.DOM = {
      wrap: document.body,
      threshold: window.innerHeight,
    }

    mediaQueryList.addEventListener("change", (event) => {
      this.listener(event)
    })
    this.listener(mediaQueryList);
    this.init()
  }
  listener(event) {
    // リサイズ時に行う処理
    this.resize()
    if (event.matches) {
      // console.log('SP用ブレークポイント用処理');
    } else {
      // console.log('PC用ブレークポイント用処理');
    }
  }
  update() {
    this.docScroll = window.pageYOffset || document.body.scrollTop
  }
  resize() {
    this.windowH = window.innerHeight
    this.threshold = window.innerHeight
  }
  init() {
    this.windowH = window.innerHeight
    this.resize()
    this.update()
    window.addEventListener('scroll', () => {
      // console.log('scroll', this.docScroll)
      // console.log('thres', this.threshold)
      this.update()
      if ( this.docScroll < this.threshold) {
        if (!document.documentElement.classList.contains(this.modifier)) {
          document.documentElement.classList.add(this.modifier)
        }
      } else {
        if (document.documentElement.classList.contains(this.modifier)) {
          document.documentElement.classList.remove(this.modifier)
        }
      }
    })
    document.body.addEventListener('load', () => {
      this.resize()
      this.update()
    })
    document.body.addEventListener('resize', () => {
      this.resize()
      this.update()
    })
  }
}
